var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model.$diff)?_c('pre',{domProps:{"innerHTML":_vm._s(_vm.diffText)}}):_c('div',{staticStyle:{"white-space":"pre-wrap"}},[_vm._ssrNode(_vm._ssrEscape(_vm._s(_vm.model.$value)))])}
var staticRenderFns = []

export { render, staticRenderFns }